import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';

export type ChargeSettingParty = { role: string; percent: number };

export type ChargeSetting = {
  _id: string,
  buyer_at: number,
  buyer_before: number,
  by_others: number,
  code: string,
  letter: string,
  number: string
  seller_at: number,
  seller_before: number,
  amount_override: number,
  payees?: ChargeSettingParty[] | null,
  payers?: ChargeSettingParty[] | null
}

export type GQLGetChargeSettings = {
  getChargeSettings: ChargeSetting[]
}

export const getChargeSettings = async () => {
  const query = gql`
    query GetChargeSettings {
      getChargeSettings {
        _id
        buyer_at
        buyer_before
        by_others
        code
        letter
        number
        seller_at
        seller_before
        amount_override
        payees {
          role
          percent
        }
        payers {
          role
          percent
        }
      }
    }
  `;

  const response = await graphQLClient().request<GQLGetChargeSettings>(query);
  return response;
};
